import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const MobileCharger: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m300 600.08h-60v-30h30v-305c0-13.79-11.21-25-25-25h-125v330h30v30h-60v-390h155c30.33 0 55 24.67 55 55z' />
    <path d='m180 90.08h30v130h-30z' />
    <path d='m554.89 586.23-194.55-162.95v-214.51h197.19v146.39l70.51 99.4-73.15 131.68zm-164.55-176.96 155.96 130.64 46.34-83.41-65.11-91.79v-125.95h-137.19v170.5z' />
    <path d='m506.9 227.56c-8.28 0-15-6.72-15-15v-11.63c0-14.4-12.47-20.85-24.83-20.85h-40.84v32.47c0 8.28-6.72 15-15 15s-15-6.72-15-15v-62.47h70.84c14.52 0 28 4.73 37.96 13.31 10.88 9.38 16.87 22.71 16.87 37.54v11.63c0 8.28-6.72 15-15 15z' />
    <path d='m720 720.08v-60s-30 0-30 0v30c0 16.57 13.43 30 30 30z' />
    <path d='m720 680.08h-30v-56.35c0-15.57-8.25-30.28-21.53-38.4l-61.29-37.45 15.64-25.6 61.29 37.45c22.14 13.53 35.89 38.05 35.89 64z' />
    <path d='m210 720.08v-150s-30 0-30 0v120c0 16.57 13.43 30 30 30z' />
  </IconBase>
));

MobileCharger.displayName = 'MobileCharger';

export default MobileCharger;
